module.exports = __webpack_public_path__ + "img/ico-close.a0d8f296.svg";